import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appNumberInteger]'
})
export class NumberIntegerDirective {

  constructor(private model:NgControl) {
  }

  @HostListener('ngModelChange') ngModelChange() {
    this.modelValue();
  }

  @HostListener('keydown.backspace') onKeyDownBackspace() {
    this.modelValue(true);
  }

  private modelValue(backspace?:boolean) {
    if (this.model) {
      let model:any = this.model;
      if (model.viewModel) {
        if (typeof model.viewModel === 'number') {
          model.viewModel = model.viewModel.toString();
        }
        this.inputChange(model.viewModel, backspace);
      }
    }
  }

  private inputChange(model: any, backspace?: any) {
    if (model) {
      let newVal = model.replace(/\D/g, '');

      if (newVal.length == 0) {
        newVal = '';
      } else {
        newVal = newVal.replace('/[^0-9]/', '');
      }

      this.model.valueAccessor.writeValue(newVal);
    }
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/directives/number-integer-mask.directive.ts
 **/